// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__2hSZ8","dropdown":"style_dropdown__PsYFF"};